import { useQuery } from '@tanstack/react-query';

import { fetchAttachmentMetadata } from '../api/FetchAttachmentMetadata';

export function useAttachmentMetadata(attachmentId: number) {
  const { data, isLoading, isFetching, isError, refetch } = useQuery({
    queryKey: ['attachment-metadata', attachmentId],
    queryFn: () => fetchAttachmentMetadata(attachmentId),
  });

  return {
    metadata: data,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
}
